import { gql } from "generated-graphql";

export const DOCUMENT_AI_ENRICHMENT_JOB_STATUS = gql(`
  query DocumentAIEnrichmentJob($id: ID!) {
    documentAIEnrichmentJob(id: $id) {
      id
      status
      documents {
        id
        title
        originalTitle
        extractionStatus
        lastExtractionAt
        extractionError
      }
    }
  }
`);
